import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'
import { useAuth } from '../context/AuthContext'
import { isTokenExpired, handleSessionExpired } from '../services/api'
import type { Permission } from '../types/domain'
import { ForceChangePasswordModal } from './ForceChangePasswordModal'

export function ProtectedRoute({
  children,
  permission,
}: {
  children: ReactNode
  /** Satu permission, atau beberapa yang mana saja boleh (mencerminkan endpoint
   *  yang menerima lebih dari satu permission). */
  permission?: Permission | Permission[]
}) {
  const { user, hasPermission, hasAnyPermission, getHomePath } = useAuth()
  const location = useLocation()

  if (!user || (user.accessToken && isTokenExpired(user.accessToken))) {
    if (user?.accessToken && isTokenExpired(user.accessToken)) {
      handleSessionExpired('Token is invalid or expired')
    }
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  if (permission) {
    const allowed = Array.isArray(permission)
      ? hasAnyPermission(...permission)
      : hasPermission(permission)
    if (!allowed) return <Navigate to={getHomePath(user.role)} replace />
  }

  return (
    <>
      <ForceChangePasswordModal />
      {children}
    </>
  )
}
